import { AmendmentOptions } from "../domain/entities/enums/i9Form-amendment";
import { II9FormRecordRepository } from "../ports/outbound/IEmployeeRecordRepository";

export class AmendSectionUseCase {
  constructor(private readonly repository: II9FormRecordRepository) {}

  async execute(
    i9FormId: string,
    amendmentOption: AmendmentOptions,
    amendmentReason: string,
    email: string | undefined
  ): Promise<void> {
    await this.repository.amendI9Form(i9FormId, amendmentOption, amendmentReason, email);
  }
}